var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 72,
    viewBox: "0 0 80 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4883 36.1549L48.8102 14.7041L11.4883 36.1549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7893 12.4167C54.052 14.615 53.294 17.4211 51.0964 18.6841L13.7746 40.1349C11.577 41.398 8.77189 40.6398 7.50924 38.4415C6.24659 36.2432 7.00451 33.4372 9.2021 32.1741L46.524 10.7233C48.7216 9.46024 51.5267 10.2184 52.7893 12.4167Z",
    fill: "#6FCF97"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3672 50.2242L57.6891 28.7734L20.3672 50.2242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6682 26.4861C62.9309 28.6844 62.1729 31.4904 59.9753 32.7535L22.6535 54.2042C20.4559 55.4673 17.6508 54.7091 16.3881 52.5108C15.1255 50.3125 15.8834 47.5065 18.081 46.2434L55.4029 24.7926C57.6005 23.5296 60.4056 24.2877 61.6682 26.4861Z",
    fill: "#6FCF97"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.25 23.3833L70.1587 21.6895L67.25 23.3833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1248 19.3795C75.3999 21.5706 74.6579 24.3809 72.4675 25.6564L69.5588 27.3502C67.3684 28.6258 64.5591 27.8835 63.284 25.6924C62.0089 23.5013 62.7509 20.691 64.9413 19.4155L67.85 17.7217C70.0404 16.4462 72.8497 17.1884 74.1248 19.3795Z",
    fill: "#6FCF97"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5352 61.7987L61.8797 45.2373L33.5352 61.7987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8424 42.9215C67.1207 45.1108 66.3828 47.9221 64.1943 49.2009L35.8498 65.7622C33.6612 67.0409 30.8508 66.3028 29.5725 64.1136C28.2942 61.9243 29.0321 59.113 31.2206 57.8343L59.5651 41.2729C61.7536 39.9942 64.564 40.7323 65.8424 42.9215Z",
    fill: "#6FCF97"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7911 47.0681C68.4545 47.0327 68.1524 47.2774 68.117 47.6141C68.0817 47.9508 68.3264 48.253 68.663 48.2884C68.9996 48.3238 69.3017 48.0791 69.3371 47.7424C69.3724 47.4058 69.1277 47.1035 68.7911 47.0681ZM67.6921 47.5694C67.7521 46.998 68.2645 46.583 68.8358 46.643C69.4071 46.7031 69.8221 47.2157 69.762 47.7871C69.702 48.3585 69.1896 48.7736 68.6183 48.7135C68.047 48.6534 67.6321 48.1408 67.6921 47.5694Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.529 64.047C19.9755 63.9887 19.4786 64.3912 19.4205 64.9448C19.3623 65.4984 19.7648 65.9955 20.3183 66.0537C20.8718 66.1119 21.3686 65.7095 21.4268 65.1559C21.4849 64.6022 21.0825 64.1052 20.529 64.047ZM18.7217 64.8713C18.8203 63.9316 19.6629 63.2492 20.6024 63.348C21.5418 63.4468 22.2242 64.2897 22.1256 65.2294C22.0269 66.169 21.1843 66.8515 20.2449 66.7527C19.3054 66.6538 18.623 65.8109 18.7217 64.8713Z",
    fill: "#6FCF97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5954 8.2872C39.0419 8.22897 38.545 8.63142 38.4869 9.18504C38.4287 9.73867 38.8312 10.2357 39.3847 10.294C39.9382 10.3522 40.435 9.94974 40.4932 9.39611C40.5513 8.84248 40.1489 8.34543 39.5954 8.2872ZM37.7881 9.11153C37.8867 8.17187 38.7293 7.4894 39.6688 7.58823C40.6082 7.68705 41.2907 8.52996 41.192 9.46962C41.0933 10.4093 40.2507 11.0918 39.3113 10.9929C38.3718 10.8941 37.6894 10.0512 37.7881 9.11153Z",
    fill: "#6FCF97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12222 25.9102C7.92116 25.9102 7.75773 26.0737 7.75773 26.2749C7.75773 26.476 7.92116 26.6395 8.12222 26.6395C8.32329 26.6395 8.48672 26.476 8.48672 26.2749C8.48672 26.0737 8.32329 25.9102 8.12222 25.9102ZM7.24414 26.2749C7.24414 25.79 7.63751 25.3965 8.12222 25.3965C8.60694 25.3965 9.00031 25.79 9.00031 26.2749C9.00031 26.7597 8.60694 27.1532 8.12222 27.1532C7.63751 27.1532 7.24414 26.7597 7.24414 26.2749Z",
    fill: "#6FCF97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3781 66.4386C56.177 66.4386 56.0136 66.602 56.0136 66.8032C56.0136 67.0043 56.177 67.1678 56.3781 67.1678C56.5791 67.1678 56.7426 67.0043 56.7426 66.8032C56.7426 66.602 56.5791 66.4386 56.3781 66.4386ZM55.5 66.8032C55.5 66.3183 55.8934 65.9248 56.3781 65.9248C56.8628 65.9248 57.2562 66.3183 57.2562 66.8032C57.2562 67.2881 56.8628 67.6816 56.3781 67.6816C55.8934 67.6816 55.5 67.2881 55.5 66.8032Z",
    fill: "#6FCF97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3501 5.40859L63.5796 7.78101L63.2949 7.68848L64.0655 5.31606L64.3501 5.40859Z",
    fill: "#6FCF97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9999 7.0946L62.6283 6.32369L62.7207 6.03906L65.0924 6.80998L64.9999 7.0946Z",
    fill: "#6FCF97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4418 46.1046L10.7545 48.5025L10.4668 48.4199L11.1541 46.0221L11.4418 46.1046Z",
    fill: "#6FCF97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1526 47.7663L9.75543 47.0787L9.83789 46.791L12.235 47.4787L12.1526 47.7663Z",
    fill: "#6FCF97"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1514 56.8546L62.5905 59.2851L62.2988 59.2178L62.8597 56.7872L63.1514 56.8546Z",
    fill: "#6FCF97"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9465 58.4768L61.5167 57.9156L61.584 57.624L64.0138 58.1852L63.9465 58.4768Z",
    fill: "#6FCF97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0861 18.4072C49.9815 18.4072 58.0159 26.4442 58.0159 36.343C58.0159 46.2417 49.9815 54.2787 40.0861 54.2787C30.1906 54.2787 22.1562 46.2417 22.1562 36.343C22.1562 26.4442 30.1906 18.4072 40.0861 18.4072Z",
    fill: "#6FCF97"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0739 20.1035C49.0335 20.1035 56.308 27.3804 56.308 36.3429C56.308 45.3055 49.0335 52.5823 40.0739 52.5823C31.1143 52.5823 23.8398 45.3055 23.8398 36.3429C23.8398 27.3804 31.1143 20.1035 40.0739 20.1035Z",
    fill: "#27AE60"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0405 31.5864L37.1389 42.4917L32.1152 37.5806L33.3702 36.296L37.1244 39.9661L46.7709 30.3164L48.0405 31.5864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/Successful.b646433629ebd6dd84c2a5a9a3bf3d7e.svg";
export { ForwardRef as ReactComponent };